import { AppState } from '../../types/store';
import { PapiDeviation } from '@wix/da-types-papi';

export const getIsRepositioning = (state: AppState): boolean =>
  state.profileHero.isRepositioning;

export const getSelectedCoverDeviation = (
  state: AppState
): PapiDeviation | null => state.profileHero.selectedCoverDeviation;
